import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AlertService, CustomerService, ErrorService, LeadService, UsersService } from '@gen/shared';
import { Router } from '@angular/router';
import { MarketplaceService } from 'libs/shared/src/lib/services/marketplace/marketplace.service';
import { StateManagementService } from 'libs/shared/src/lib/state-management/state-management.service';
import { combineLatest, map, mergeMap, of, startWith } from 'rxjs';

@Component({
  selector: 'app-internal',
  templateUrl: './internal.component.html',
  styleUrls: ['./internal.component.scss'],
})
export class InternalComponent implements OnInit {
  public title: string = '';

  public loading: boolean = false;

  public user: any = {};

  constructor(
    private $notification: StateManagementService,
    private readonly $user: UsersService,
    private readonly $lead: LeadService,
    private $marketplace: MarketplaceService,
    private $alert: AlertService,
    private route: Router
  ) {}

  public ngOnInit(): void {
    this.getTitle();
    this.getInfo();
    this.$marketplace.getAndSetActiveCart();
  }

  private getTitle(): void {
    this.$notification.titles.subscribe((res) => {
      this.title = res;
    });
  }

  private getInfo(): void {
    this.loading = true;

    this.$lead.currentLead().subscribe({
      next: (res) => {
        if (res.data?.currentLead) {
          this.$notification.setUser(res.data.currentLead);
          this.user = JSON.parse(JSON.stringify(res.data.currentLead));
          return res.data.currentUser;
        }

        return undefined;
      },

      error: (error) => {
        this.$alert.setAlertInfo('ERROR', error);
        this.loading = false;
        throw new Error(error);
      },
    });
  }

  public checkShowFooter(): boolean {
    const verifyRoute = this.route.url;

    if (verifyRoute.includes('/cart')) {
      return false;
    }

    return true;
  }
}
